import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store.js";
import i18n from "../i18n.js";
import Home from "../views/Home.vue";
import axios from "axios";

import ListInvestigators from "../components/investigators/ListInvestigators";
import DetailInvestigator from "../components/investigators/DetailInvestigator";
import Processors from "../views/Processors";
import Reviews from "../views/Reviews";
import ReviewDelete from "../components/delete_object/ReviewDelete";
import ListPublications from "../components/publications/ListPublications";
import MyForms from "../views/MyForms";
import UnauthorizedAccess from "../views/UnauthorizedAccess";
import AccountTabs from "../components/users/AccountTabs";
import FormsQueue from "../components/forms/FormsQueue";
import FormsQueueHistory from "../components/forms/FormsQueueHistory";
import Login from "../components/reusables/Login";
import ActivateAccount from "../components/reusables/ActivateAccount";
import DetailPublication from "../components/publications/DetailPublication";
import AuthorizeFormsQueue from "../components/forms/AuthorizeFormsQueue";
import InvestigatorForms from "../components/investigators/forms/InvestigatorForms";
import NewInvestigatorForm from "../components/investigators/forms/NewInvestigatorForm";
import ExternalPeopleAccountForm from "../components/investigators/forms/ExternalPeopleAccountForm";
import EditList from "../views/direct_edit/EditListObjects";
import EditObject from "../views/direct_edit/EditObject";
import NewArticleForm from "../components/publications/forms/NewArticleForm";
import ImportScopus from "../components/publications/forms/ImportScopus";
import PublicationForms from "../components/publications/forms/PublicationForms";
import EditInvestigatorDetail from "../views/direct_edit/investigators/EditInvestigatorDetail";
import EditPublicationDetail from "../views/direct_edit/publications/EditPublicationDetail";
import NewBookAndChapterForm from "../components/publications/forms/NewBookAndChapterForm";
import NewCommunicationForm from "../components/publications/forms/NewCommunicationForm";
import NewThesisForm from "../components/publications/forms/NewThesisForm";
import HomeIndicators from "../components/publications/indicators/HomeIndicators";
import EditResearchAreaDetail from "../views/direct_edit/EditResearchAreaDetail";
import NotificationLink from "../components/reusables/NotificationLink";
import EditOrganizationDetail from "../views/direct_edit/EditOrganizationDetail";
import ListProjects from "../components/projects/ListProjects";
import DetailProjects from "../components/projects/DetailProjects";
import ProjectForms from "../components/projects/forms/ProjectForms";
import NewProjectForm from "../components/projects/forms/NewProjectForm";
import EditProjectDetail from "../views/direct_edit/EditProjectDetail";
import EditFunderProgramDetail from "../views/direct_edit/EditFunderProgramDetail";
import PressNewForms from "@/components/newsPress/forms/PressNewForms";
import ListNews from "@/components/newsPress/ListNews";
import DetailNews from "@/components/newsPress/DetailNews";
import NewPressNewForm from "@/components/newsPress/forms/NewPressNewForm";
import EditPressNewDetail from "../views/direct_edit/EditPressNewDetail";
import GeneralPlan from "@/views/building/GeneralPlan";
import LegacyGeneralPlan from "@/views/building/LegacyGeneralPlan";
import ListStays from "../components/stays/ListStays";
import DetailStays from "../components/stays/DetailStays";
import StayForms from "../components/stays/forms/StayForms";
import NewStayForm from "../components/stays/forms/NewStayForm";
import EditStayDetail from "../views/direct_edit/EditStayDetail.vue";
import EditSoftwareDetail from "../views/direct_edit/EditSoftwareDetail.vue";
import ListSoftware from "@/components/software/ListSoftware.vue";
import DetailSoftware from "@/components/software/DetailSoftware.vue";
import SoftwareForms from "@/components/software/forms/SoftwareForms.vue";
import NewSoftwareForm from "@/components/software/forms/NewSoftwareForm.vue";
import ListDatasets from "@/components/datasets/ListDatasets.vue";
import DetailDataset from "@/components/datasets/DetailDataset.vue";
import DatasetForms from "@/components/datasets/forms/DatasetForms.vue";
import NewDatasetForm from "@/components/datasets/forms/NewDatasetForm.vue";
import EditDatasetDetail from "@/views/direct_edit/EditDatasetDetail.vue";
import DetailIndustrialProperty from "@/components/industrialProperty/DetailIndustrialProperty.vue";
import IndustrialPropertyForms from "@/components/industrialProperty/forms/IndustrialPropertyForms.vue";
import ListIndustrialProperties from "@/components/industrialProperty/ListIndustrialProperties.vue";
import NewIndustrialPropertyForm from "@/components/industrialProperty/forms/NewIndustrialPropertyForm.vue";
import EditIndustrialPropertyDetail from "@/views/direct_edit/EditIndustrialPropertyDetail.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: true,
          href: "/"
        }
      ],
      title: "section.home"
    }
  },
  {
    path: "/activate-account",
    name: "Activate Account",
    component: ActivateAccount
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/notification/:id",
    name: "notificationLink",
    component: NotificationLink
  },
  {
    path: "/building/legacy",
    name: "Legacy General Plan",
    component: LegacyGeneralPlan,
    meta: {
      requiresAuth: true,
      title: "section.general_plan",
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.general_plan", disabled: true }
      ]
    }
  },
  {
    path: "/building",
    name: "General Plan",
    component: GeneralPlan,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.general_plan",
          disabled: true
        }
      ],
      title: "section.general_plan"
    }
  },
  {
    path: "/researchers",
    name: "Researchers",
    component: ListInvestigators,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.investigators",
          disabled: true
        }
      ],
      title: "section.investigators"
    }
  },
  {
    path: "/investigators",
    redirect: { name: "Researchers"}  
  },
  {
    path: "/researchers/:id",
    name: "Researcher",
    component: DetailInvestigator,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.investigators",
          disabled: false,
          href: "/researchers",
          exact: true
        }
      ]
    }
  },
  {
    path: "/investigators/:id",
    redirect: { name: "Researcher"}  
  },
  {
    path: "/researchers/:id/forms/:formName",
    name: "Create form to update researcher info",
    component: InvestigatorForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.investigators",
          disabled: false,
          href: "/researchers",
          exact: true
        }
      ],
      title: "section.create"
    }
  },
  {
    path: "/investigators/:id/forms/:formName",
    redirect: { name: "Create form to update researcher info"}  
  },
  {
    path: "/publications",
    name: "Publications",
    component: ListPublications,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: true
        }
      ],
      title: "section.publications"
    }
  },
  {
    path: "/publications/:id",
    name: "Publication",
    component: DetailPublication,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/publications",
          exact: true
        }
      ]
    }
  },
  {
    path: "/publications/:id/forms/:formName",
    name: "Create form to update publication",
    component: PublicationForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/publications",
          exact: true
        }
      ],
      title: "section.modifyBasicDataForm"
    }
  },
  {
    path: "/projects",
    name: "Projects",
    component: ListProjects,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.projects",
          disabled: true
        }
      ],
      title: "section.projects"
    }
  },
  {
    path: "/projects/:id",
    name: "Project",
    component: DetailProjects,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.projects",
          disabled: false,
          href: "/projects",
          exact: true
        }
      ]
    }
  },
  {
    path: "/projects/:id/forms/:formName",
    name: "Create form to update project",
    component: ProjectForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.projects",
          disabled: false,
          href: "/projects",
          exact: true
        }
      ],
      title: "section.create"
    }
  },
  {
    path: "/my-forms/project/newProject",
    name: "Project Form",
    component: NewProjectForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.projects",
          disabled: false,
          href: "/projects"
        },
        {
          text: "project.forms.newProject",
          disabled: true
        }
      ],
      title: "project.forms.newProject"
    }
  },
  {
    path: "/stays",
    name: "Stays",
    component: ListStays,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.stays",
          disabled: true
        }
      ],
      title: "section.stays"
    }
  },
  {
    path: "/stays/:id",
    name: "Stay",
    component: DetailStays,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.stays",
          disabled: false,
          href: "/stays",
          exact: true
        }
      ]
    }
  },
  {
    path: "/stays/:id/forms/:formName",
    name: "Create form to update stay",
    component: StayForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.stays",
          disabled: false,
          href: "/stays",
          exact: true
        }
      ],
      title: "section.create"
    }
  },
  {
    path: "/my-forms/stay/newStay",
    name: "Stay Form",
    component: NewStayForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.stays",
          disabled: false,
          href: "/stays"
        },
        {
          text: "stay.forms.newStay",
          disabled: true
        }
      ],
      title: "stay.forms.newStay"
    }
  },
  {
    path: "/softwares",
    name: "Software",
    component: ListSoftware,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.softwares", disabled: true }
      ],
      title: "section.softwares"
    }
  },
  {
    path: "/softwares/:id",
    name: "Software detail",
    component: DetailSoftware,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.softwares", disabled: false, href: "/softwares", exact: true }
      ],
      title: "section.softwares"
    }
  },
  {
    path: "/softwares/:id/forms/:formName",
    name: "Create form to update software",
    component: SoftwareForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.softwares", disabled: false, href: "/softwares", exact: true },
        { text: "section.modifySoftwareForm", disabled: true }
      ],
      title: "section.modifySoftwareForm"
    }
  },
  {
    path: "/my-forms/software/newSoftware",
    name: "Software form",
    component: NewSoftwareForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.softwares", disabled: false, href: "/softwares" },
        { text: "software.forms.newSoftware", disabled: true }
      ],
      title: "software.forms.newSoftware"
    }
  },
  {
    path: "/datasets",
    name: "Datasets",
    component: ListDatasets,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.datasets", disabled: true }
      ],
      title: "section.datasets"
    }
  },
  {
    path: "/datasets/:id",
    name: "Dataset detail",
    component: DetailDataset,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.datasets", disabled: false, href: "/datasets", exact: true }
      ],
      title: "section.datasets"
    }
  },
  {
    path: "/datasets/:id/forms/:formName",
    name: "Create form to update dataset",
    component: DatasetForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.datasets", disabled: false, href: "/datasets", exact: true },
        { text: "section.modifyDatasetForm", disabled: true }
      ],
      title: "section.modifyDatasetForm"
    }
  },
  {
    path: "/my-forms/dataset/newDataset",
    name: "Dataset form",
    component: NewDatasetForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.datasets", disabled: false, href: "/datasets" },
        { text: "dataset.forms.newDataset", disabled: true }
      ],
      title: "dataset.forms.newDataset"
    }
  },
  {
    path: "/industrial-property",
    name: "Industrial property",
    component: ListIndustrialProperties,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.industrial_property", disabled: true }
      ],
      title: "section.industrial_property"
    }
  },
  {
    path: "/industrial-property/:id",
    name: "Industrial property detail",
    component: DetailIndustrialProperty,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.industrial_property", disabled: false, href: "/industrial-property", exact: true }
      ],
      title: "section.industrial_property"
    }
  },
  {
    path: "/industrial-property/:id/forms/:formName",
    name: "Create form to update industrial property",
    component: IndustrialPropertyForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.industrial_property", disabled: false, href: "/industrial-property", exact: true },
        { text: "section.modifyIndustrialPropertyForm", disabled: true }
      ],
      title: "section.modifyIndustrialPropertyForm"
    }
  },
  {
    path: "/my-forms/industrial_property/newIndustrialProperty",
    name: "Industrial property form",
    component: NewIndustrialPropertyForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.industrial_property", disabled: false, href: "/industrial-property" },
        { text: "industrial_property.forms.newIndustrialProperty", disabled: true }
      ],
      title: "industrial_property.forms.newIndustrialProperty"
    }
  },
  {
    path: "/news/:id/forms/:formName",
    name: "Create form to update pressNew",
    component: PressNewForms,
    meta: {
      requiresAuth: true,
      update: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.pressNews",
          disabled: false,
          href: "/pressNews",
          exact: true
        }
      ],
      title: "section.create"
    }
  },
  {
    path: "/pressNews",
    name: "News Press list",
    component: ListNews,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.pressNews",
          disabled: true
        }
      ],
      title: "section.pressNews"
    }
  },
  {
    path: "/pressNews/:id",
    name: "News Press detail",
    component: DetailNews,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.pressNews",
          disabled: false,
          href: "/pressNews",
          exact: true
        }
      ]
    }
  },
  {
    path: "/my-forms/pressNew/newPressNew",
    name: "New pressNew Form",
    component: NewPressNewForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.pressNews",
          disabled: false,
          href: "/pressNews"
        },
        {
          text: "pressNew.forms.newPressNew",
          disabled: true
        }
      ],
      title: "pressNew.forms.newPressNew"
    }
  },
  {
    path: "/my-forms/publication/manual",
    name: "New article Form",
    component: NewArticleForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/publications"
        },
        {
          text: "publication.forms.newArticle",
          disabled: true
        }
      ],
      title: "publication.forms.newArticle"
    }
  },
  {
    path: "/my-forms/publication/scopus",
    name: "Import scopus publication",
    component: ImportScopus,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/publications"
        },
        {
          text: "publication.forms.importScopus",
          disabled: true
        }
      ],
      title: "publication.forms.importScopus"
    }
  },
  {
    path: "/my-forms/publication/bookChapter",
    name: "Create book or chapter",
    component: NewBookAndChapterForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/publications"
        },
        {
          text: "publication.forms.newBookChapter",
          disabled: true
        }
      ],
      title: "publication.forms.newBookChapter"
    }
  },
  {
    path: "/my-forms/publication/communication",
    name: "Create communication",
    component: NewCommunicationForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/publications"
        },
        {
          text: "publication.forms.newCommunication",
          disabled: true
        }
      ],
      title: "publication.forms.newCommunication"
    }
  },
  {
    path: "/my-forms/publication/thesis",
    name: "Create thesis",
    component: NewThesisForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/publications"
        },
        {
          text: "publication.forms.newThesis",
          disabled: true
        }
      ],
      title: "publication.forms.newThesis"
    }
  },
  {
    path: "/my-forms/researcher/newResearcher",
    name: "Researcher Form",
    component: NewInvestigatorForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.investigators",
          disabled: false,
          href: "/researchers"
        },
        {
          text: "investigator.forms.newResearcher",
          disabled: true
        }
      ],
      title: "investigator.forms.newResearcher"
    }
  },
  {
    path: "/my-forms/researcher/newResearcher",
    redirect: { name: "Researcher Form"}  
  },
  {
    path: "/my-forms/researcher/newInvestigator",
    redirect: { name: "Researcher Form"}  
  },
  {
    path: "/my-forms/researcher/newExternal",
    name: "External people Form",
    component: ExternalPeopleAccountForm,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.investigators",
          disabled: false,
          href: "/researchers"
        },
        {
          text: "investigator.forms.newExternal",
          disabled: true
        }
      ],
      title: "investigator.forms.newExternal"
    }
  },
  {
    path: "/my-forms/researcher/newExternal",
    redirect: { name: "External People Form"}  
  },
  {
    path: "/my-forms/researcher/see/:formName/:id",
    name: "SeeInvestigatorForm",
    component: InvestigatorForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.investigators",
          disabled: true
        },
        {
          text: "section.see",
          disabled: true
        }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/investigator/see/:formName/:id",
    redirect: { name: "SeeInvestigatorForm"}  
  },
  {
    path: "/my-forms/publication/see/:formName/:id",
    name: "SeePublication",
    component: PublicationForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.publications",
          disabled: true
        },
        {
          text: "section.see",
          disabled: true
        }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/project/see/:formName/:id",
    name: "SeeProjectForm",
    component: ProjectForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.projects",
          disabled: true
        },
        {
          text: "section.see",
          disabled: true
        }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/news/see/:formName/:id",
    name: "SeeProjectForm",
    component: PressNewForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.pressNews",
          disabled: true
        },
        {
          text: "section.see",
          disabled: true
        }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/stay/see/:formName/:id",
    name: "SeeStayForm",
    component: StayForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.stays",
          disabled: true
        },
        {
          text: "section.see",
          disabled: true
        }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/software/see/:formName/:id",
    name: "SeeSoftwareForm",
    component: SoftwareForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.myForms", disabled: false, href: "/my-forms", exact: true },
        { text: "section.softwares", disabled: true },
        { text: "section.see", disabled: true }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/dataset/see/:formName/:id",
    name: "SeeDatasetForm",
    component: DatasetForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.myForms", disabled: false, href: "/my-forms", exact: true },
        { text: "section.datasets", disabled: true },
        { text: "section.see", disabled: true }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/industrial_property/see/:formName/:id",
    name: "SeeIndustrialPropertyForm",
    component: IndustrialPropertyForms,
    meta: {
      readOnly: true,
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.myForms", disabled: false, href: "/my-forms", exact: true },
        { text: "section.industrial_property", disabled: true },
        { text: "section.see", disabled: true }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-forms/publication/:formName/:id",
    name: "EditPublicationForm",
    component: PublicationForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.publications",
          disabled: true
        },
        {
          text: "section.edit",
          disabled: true
        }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/researcher/:formName/:id",
    name: "EditInvestigatorForm",
    component: InvestigatorForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.investigators",
          disabled: true
        },
        {
          text: "section.edit",
          disabled: true
        }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/investigator/:formName/:id",
    redirect: { name: "EditInvestigatorForm"}  
  },
  {
    path: "/my-forms/project/:formName/:id",
    name: "EditProjectForm",
    component: ProjectForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.projects",
          disabled: true
        },
        {
          text: "section.edit",
          disabled: true
        }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/news/:formName/:id",
    name: "EditPressNewForm",
    component: PressNewForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.pressNews",
          disabled: true
        },
        {
          text: "section.edit",
          disabled: true
        }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/stay/:formName/:id",
    name: "EditStayForm",
    component: StayForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.stays",
          disabled: true
        },
        {
          text: "section.edit",
          disabled: true
        }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/software/:formName/:id",
    name: "EditSoftwareForm",
    component: SoftwareForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.myForms", disabled: false, href: "/my-forms", exact: true },
        { text: "section.softwares", disabled: true },
        { text: "section.edit", disabled: true }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/dataset/:formName/:id",
    name: "EditDatasetForm",
    component: DatasetForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.myForms", disabled: false, href: "/my-forms", exact: true },
        { text: "section.datasets", disabled: true },
        { text: "section.edit", disabled: true }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/industrial_property/:formName/:id",
    name: "EditIndustrialPropertyForm",
    component: IndustrialPropertyForms,
    meta: {
      updateForm: true,
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.myForms", disabled: false, href: "/my-forms", exact: true },
        { text: "section.industrial_property", disabled: true },
        { text: "section.edit", disabled: true }
      ],
      title: "section.edit"
    }
  },
  {
    path: "/my-forms/:object_type/delete/see/:id",
    name: "See review delete",
    component: ReviewDelete,
    meta: {
      see_user: true,
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: false,
          href: "/my-forms",
          exact: true
        },
        {
          text: "section.deleteForm",
          disabled: true
        },
        {
          text: "section.see",
          disabled: true
        }
      ],
      title: "section.see"
    }
  },
  {
    path: "/my-account",
    name: "My account",
    component: AccountTabs,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myAccount",
          disabled: true
        }
      ],
      title: "section.myAccount"
    }
  },
  {
    path: "/my-forms",
    name: "My forms",
    component: MyForms,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.myForms",
          disabled: true
        }
      ],
      title: "section.myForms"
    }
  },
  {
    path: "/manage/forms",
    name: "Manage forms",
    component: FormsQueue,
    meta: {
      requiresAuth: true,
      permission: ["apoyo"],
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.manageForms",
          disabled: true
        }
      ],
      title: "section.manageForms"
    }
  },
  {
    path: "/manage/forms/history",
    name: "Finished forms history",
    component: FormsQueueHistory,
    meta: {
      requiresAuth: true,
      permission: ["apoyo"],
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.manageForms",
          disabled: false,
          href: "/manage/forms",
          exact: true
        },
        {
          text: "section.manageFormsHistory",
          disabled: true
        }
      ],
      title: "section.manageFormsHistory"
    }
  },
  {
    path: "/indicators",
    name: "Indicators",
    component: HomeIndicators,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.indicators",
          disabled: true
        }
      ],
      title: "section.indicators"
    }
  },
  {
    path: "/manage/edit",
    name: "Manage edit",
    component: EditList,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: true
        }
      ],
      title: "section.directEdit"
    }
  },
  {
    path: "/manage/edit/:object_name",
    name: "Manage edit object",
    component: EditObject,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        }
      ]
    }
  },
  {
    path: "/manage/edit/researchers/add",
    name: "Add researcher admin page",
    component: EditInvestigatorDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.investigators",
          disabled: false,
          href: "/manage/edit/researchers",
          exact: true
        },
        {
          text: "section.addInvestigator",
          disabled: true
        }
      ],
      title: "section.addInvestigator"
    }
  },
  {
    path: "/manage/edit/investigators/add",
    redirect: { name: "Add researcher admin page"}  
  },
  {
    path: "/manage/edit/researchers/edit/:id",
    name: "Edit researcher admin page",
    component: EditInvestigatorDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.investigators",
          disabled: false,
          href: "/manage/edit/researchers",
          exact: true
        },
        {
          text: "section.editInvestigator",
          disabled: true
        }
      ],
      title: "section.editInvestigator"
    }
  },
  {
    path: "/manage/edit/investigators/edit/:id",
    redirect: { name: "Edit researcher admin page"}  
  },
  {
    path: "/manage/edit/publications/add/:type",
    name: "Add publication admin page",
    component: EditPublicationDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/manage/edit/publications",
          exact: true
        },
        {
          text: "section.addPublication",
          disabled: true
        }
      ],
      title: "section.addPublication"
    }
  },
  {
    path: "/manage/edit/publications/edit/:id",
    name: "Edit publication admin page",
    component: EditPublicationDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.publications",
          disabled: false,
          href: "/manage/edit/publications",
          exact: true
        },
        {
          text: "section.editPublication",
          disabled: true
        }
      ],
      title: "section.editPublication"
    }
  },
  {
    path: "/manage/edit/organization/add",
    name: "Add organization admin page",
    component: EditOrganizationDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.organization",
          disabled: false,
          href: "/manage/edit/organizations",
          exact: true
        },
        {
          text: "section.addOrganization",
          disabled: true
        }
      ],
      title: "section.addOrganization"
    }
  },
  {
    path: "/manage/edit/organization/edit/:id",
    name: "Edit Organization admin page",
    component: EditOrganizationDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.organization",
          disabled: false,
          href: "/manage/edit/organizations",
          exact: true
        },
        {
          text: "section.editOrganization",
          disabled: true
        }
      ],
      title: "section.editOrganization"
    }
  },
  {
    path: "/manage/edit/pressNews/add",
    name: "Add pressNew admin page",
    component: EditPressNewDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.pressNews",
          disabled: false,
          href: "/manage/edit/pressNews",
          exact: true
        },
        {
          text: "section.addPressNews",
          disabled: true
        }
      ],
      title: "section.addPressNews"
    }
  },
  {
    path: "/manage/edit/pressNews/edit/:id",
    name: "Edit pressNew admin page",
    component: EditPressNewDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.pressNews",
          disabled: false,
          href: "/manage/edit/pressNews",
          exact: true
        },
        {
          text: "section.editPressNews",
          disabled: true
        }
      ],
      title: "section.editPressNews"
    }
  },
  {
    path: "/manage/edit/project/add",
    name: "Add project admin page",
    component: EditProjectDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.projects",
          disabled: false,
          href: "/manage/edit/projects",
          exact: true
        },
        {
          text: "section.addProject",
          disabled: true
        }
      ],
      title: "section.addProject"
    }
  },
  {
    path: "/manage/edit/project/edit/:id",
    name: "Edit project admin page",
    component: EditProjectDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.projects",
          disabled: false,
          href: "/manage/edit/projects",
          exact: true
        },
        {
          text: "section.editProject",
          disabled: true
        }
      ],
      title: "section.editProject"
    }
  },
  {
    path: "/manage/edit/funderProgram/add",
    name: "Add funderProgram admin page",
    component: EditFunderProgramDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.funderPrograms",
          disabled: false,
          href: "/manage/edit/funderPrograms",
          exact: true
        },
        {
          text: "section.addFunderProgram",
          disabled: true
        }
      ],
      title: "section.addFunderProgram"
    }
  },
  {
    path: "/manage/edit/funderProgram/edit/:id",
    name: "Edit funderProgram admin page",
    component: EditFunderProgramDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.funderPrograms",
          disabled: false,
          href: "/manage/edit/funderPrograms",
          exact: true
        },
        {
          text: "section.editFunderProgram",
          disabled: true
        }
      ],
      title: "section.editFunderProgram"
    }
  },
  {
    path: "/manage/edit/researchArea/add",
    name: "Add researchArea admin page",
    component: EditResearchAreaDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.researchAreas",
          disabled: false,
          href: "/manage/edit/researchAreas",
          exact: true
        },
        {
          text: "section.addResearchArea",
          disabled: true
        }
      ],
      title: "section.addResearchArea"
    }
  },
  {
    path: "/manage/edit/researchArea/edit/:id",
    name: "Edit researchArea admin page",
    component: EditResearchAreaDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.researchAreas",
          disabled: false,
          href: "/manage/edit/researchAreas",
          exact: true
        },
        {
          text: "section.editResearchArea",
          disabled: true
        }
      ],
      title: "section.editResearchArea"
    }
  },
  {
    path: "/manage/forms/:object_type/:form_name/:id",
    name: "Review form",
    component: Reviews,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.manageForms",
          href: "/manage/forms",
          exact: true
        },
        {
          text: "section.review",
          disabled: true
        }
      ],
      title: "section.review"
    }
  },
  {
    path: "/manage/forms/process/:object_type/:form_name/:id",
    name: "Procesor forms",
    component: Processors,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.manageForms",
          href: "/manage/forms",
          exact: true
        },
        {
          text: "section.process",
          disabled: true
        }
      ],
      title: "section.process"
    }
  },
  {
    path: "/direction/forms/authorize",
    name: "Authorize form",
    component: AuthorizeFormsQueue,
    meta: {
      permission: ["apoyo", "direccion"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.authorizeForms",
          disabled: true
        }
      ],
      title: "section.authorizeForms"
    }
  },
  {
    path: "/direction/forms/authorize/:object_type/:form_name/:id",
    name: "Authorize form review",
    component: Reviews,
    meta: {
      permission: ["apoyo", "direccion"],
      requiresAuth: true,
      authorize: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.authorizeForms",
          disabled: false,
          exact: true,
          href: "/direction/forms/authorize"
        }
      ],
      title: "section.review"
    }
  },
  {
    path: "/unauthorizedAccess",
    name: "unauthorized access",
    component: Home
  },
  {
    path: "/manage/edit/stays/add/:type",
    name: "Add stays admin page",
    component: EditStayDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.stays",
          disabled: false,
          href: "/manage/edit/stays",
          exact: true
        },
        {
          text: "section.addStay",
          disabled: true
        }
      ],
      title: "section.addStay"
    }
  },
  {
    path: "/manage/edit/stays/edit/:id",
    name: "Edit stay admin page",
    component: EditStayDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.stays",
          disabled: false,
          href: "/manage/edit/stays",
          exact: true
        },
        {
          text: "section.editStay",
          disabled: true
        }
      ],
      title: "section.editStay"
    }
  },
  {
    path: "/manage/edit/stays/add",
    name: "Add stay admin page",
    component: EditStayDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.stays",
          disabled: false,
          href: "/manage/edit/stays",
          exact: true
        },
        {
          text: "section.addStay",
          disabled: true
        }
      ],
      title: "section.addStay"
    }
  },
  {
    path: "/manage/edit/softwares/add/:type",
    name: "Add softwares admin page",
    component: EditSoftwareDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.softwares",
          disabled: false,
          href: "/manage/edit/softwares",
          exact: true
        },
        {
          text: "section.addSoftware",
          disabled: true
        }
      ],
      title: "section.addSoftware"
    }
  },
  {
    path: "/manage/edit/softwares/edit/:id",
    name: "Edit software admin page",
    component: EditSoftwareDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.softwares",
          disabled: false,
          href: "/manage/edit/softwares",
          exact: true
        },
        {
          text: "section.editSoftware",
          disabled: true
        }
      ],
      title: "section.editSoftware"
    }
  },
  {
    path: "/manage/edit/softwares/add",
    name: "Add software admin page",
    component: EditSoftwareDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        {
          text: "section.home",
          disabled: false,
          href: "/"
        },
        {
          text: "section.directEdit",
          disabled: false,
          href: "/manage/edit",
          exact: true
        },
        {
          text: "section.softwares",
          disabled: false,
          href: "/manage/edit/softwares",
          exact: true
        },
        {
          text: "section.addSoftware",
          disabled: true
        }
      ],
      title: "section.addSoftware"
    }
  },
  {
    path: "/manage/edit/datasets/edit/:id",
    name: "Edit dataset admin page",
    component: EditDatasetDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.directEdit", disabled: false, href: "/manage/edit", exact: true },
        { text: "section.datasets", disabled: false, href: "/manage/edit/datasets", exact: true },
        { text: "section.editDataset", disabled: true }
      ],
      title: "section.editDataset"
    }
  },
  {
    path: "/manage/edit/datasets/add",
    name: "Add dataset admin page",
    component: EditDatasetDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.directEdit", disabled: false, href: "/manage/edit", exact: true },
        { text: "section.datasets", disabled: false, href: "/manage/edit/datasets", exact: true },
        { text: "section.addDataset", disabled: true }
      ],
      title: "section.addDataset"
    }
  },
  {
    path: "/manage/edit/industrialProperties/edit/:id",
    name: "Edit industrial property admin page",
    component: EditIndustrialPropertyDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.directEdit", disabled: false, href: "/manage/edit", exact: true },
        { text: "section.industrial_property", disabled: false, href: "/manage/edit/industrialProperties", exact: true },
        { text: "section.editIndustrialProperty", disabled: true }
      ],
      title: "section.editIndustrialProperty"
    }
  },
  {
    path: "/manage/edit/industrialProperties/add",
    name: "Add industrial property admin page",
    component: EditIndustrialPropertyDetail,
    meta: {
      permission: ["apoyo"],
      requiresAuth: true,
      breadCrumb: [
        { text: "section.home", disabled: false, href: "/" },
        { text: "section.directEdit", disabled: false, href: "/manage/edit", exact: true },
        { text: "section.industrial_property", disabled: false, href: "/manage/edit/industrialProperties", exact: true },
        { text: "section.addIndustrialProperty", disabled: true }
      ],
      title: "section.addIndustrialProperty"
    }
  },

  // otherwise redirect to home
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  routes,
  mode: "history",
  base:
    process.env.NODE_ENV === "production"
      ? process.env.VUE_APP_PROD_INIT_PATH
      : process.env.VUE_APP_DEB_INIT_PATH
});

function getRouteTitleKey(route) {
  if (route.meta.title) {
    return route.meta.title;
  }

  if (route.name === "Manage edit object" && route.params.object_name) {
    const objectName = route.params.object_name;
    return (
      "section.manage" +
      objectName.charAt(0).toUpperCase() +
      objectName.slice(1)
    );
  }

  return null;
}

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = "Xici";
    const titleKey = getRouteTitleKey(to);
    if (to.meta.breadCrumb && titleKey) {
      document.title += " - " + i18n.t(titleKey);
    }
  });
});

router.beforeEach((to, from, next) => {
  const titleKey = getRouteTitleKey(to);
  if (titleKey) {
    store.state.sectionTitle = titleKey;
  }
  if (store.state.language && store.state.language !== i18n.locale) {
    i18n.locale = store.state.language;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (store.state.hasCodeRunBefore === null && store.getters.isInternal) {
        axios
          .get(store.state.endpoint + "/user/moderatedOperations")
          .catch(error => {
            store.dispatch("forceLogout").then(() => {
              next({
                path: "/login",
                query: { redirect: to.fullPath }
              });
            });
          });
        store.dispatch("setCheckToken");
      }
      if (to.matched.some(record => record.meta.permission)) {
        let groups = store.getters.user.groups;
        let permissionGroups = to.meta.permission;
        if (store.getters.user.is_superuser) {
          next();
          return;
        }
        for (let group in groups) {
          if (permissionGroups.includes(groups[group].name)) {
            next();
            return;
          }
        }
        next("/unauthorizedAccess");
        return;
      } else {
        next();
        return;
      }
    }
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
    return;
  } else {
    next();
  }
});

export default router;
